import React from 'react'
import Register from './Register'

const Auth = () => {
  return (
    <div>
        <Register/>
    </div>
  )
}

export default Auth
